var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"block p-3 text-left border rounded cursor-pointer focus:outline-none",class:[
        {
            'border-red': _vm.$validator.has(_vm.validatorName, _vm.sid)
        },
        _vm.is_checked
            ? 'bg-blue-lightest border-blue hover:border-blue-darker'
            : 'hover:border-grey',
        {
            'cursor-not-allowed': _vm.disabled,
            'bg-grey-bg': _vm.disabled && !_vm.is_checked,
            'focus:shadow-outline': !_vm.disabled
        }
    ],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"flex-grow leading-none"},[_vm._t("label",[_vm._v("Label")])],2),_vm._v(" "),_c('base-svg',{staticClass:"flex-none w-4 h-4 fill-primary-blue-dark fill-secondary-blue-lighter",class:_vm.is_checked ? 'block' : 'hidden',attrs:{"name":"icon-check-circle"}})],1),_vm._v(" "),(!!_vm.$slots['hint'])?_c('div',{staticClass:"mt-2 text-sm leading-tight text-grey-darker"},[_vm._t("hint")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }